import {Component, inject, input} from '@angular/core'
import {FormGroup, ReactiveFormsModule} from '@angular/forms'
import {MatError} from '@angular/material/form-field'
import {MatIcon} from '@angular/material/icon'
import {MatRadioButton, MatRadioGroup} from '@angular/material/radio'
import {IKycForm} from '@sparbanken-syd/spb-savings-account-backend'
import {OrientationService} from '../../../services/orientation.service'

@Component({
  selector: 'spb-american-citizenship',
  templateUrl: './american-citizenship.component.html',
  styleUrl: '../kyc.component.scss',
  imports: [ReactiveFormsModule, MatRadioGroup, MatRadioButton, MatError, MatIcon]
})
export class AmericanCitizenshipComponent {
  public americanCitizenshipForm = input.required<FormGroup>()
  public kycForm = input.required<IKycForm>()

  protected readonly orientationService = inject(OrientationService)

  get hasAmericanCitizenshipError(): boolean {
    return this.americanCitizenshipForm().controls.americanCitizenship.value === false &&
      (this.kycForm().primaryResidenceForm.primaryResidence === 'USA' ||
        this.kycForm().birthForm.birthCountry === 'USA' ||
        this.kycForm().birthForm.citizenship.includes('USA') ||
        this.kycForm().greenCardForm.greenCard)
  }

  get citizenshipErrorId(): string | null {
    return this.hasAmericanCitizenshipError ? 'citizenship-error' : null
  }

}
